export const messageCodes = {
    consentBody: 'EMPLOYEE_PWD_RESET_CONSENT_BODY',
    consentCheckbox: 'EMPLOYEE_PWD_RESET_CONSENT_CB',
    resetError: 'EMPLOYEE_PWD_CHANGE_ERROR',
    resetSuccess: 'EMPLOYEE_PWD_CHANGE_SUCCESS',
    userInfo: 'EMPLOYEE_PWD_USER_INFO'
};

export const languageCacheKey = 'EmployeePasswordResetLang';